<template>
  <div>
    <el-form
      ref="form"
      size="mini"
      label-position="right"
      label-width="130px"
      class="demo-form-inline"
      
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="EMC检测报告:">
            <a :href="form.emcFile" :disabled="emcDisabled" v-if="form.emcFile" target="_blank">
              {{ form.emcFile }}
            </a>
            <br/>
            <el-input
              style="width:100%"
              placeholder="EMC检测报告"
              class="longInput"
              type="file"
              accept="application/vnd.ms-excel"
              id="fileinput_emc"
              v-model="upload_file"
              @change="tirggerFile($event)"
              :disabled="disabled"
            >
            </el-input>
            <el-button @click="_uploadFile" type="warning" :disabled="disabled">上传</el-button>
          </el-form-item>
        </el-col>
        <el-col  :sm="24" :md="12">
          <el-form-item label="阴阳比值：">
            <el-input v-model="form.yinYangRatio" :disabled="disabled"></el-input>
          </el-form-item>
        </el-col>
        <el-col  :sm="24" :md="12">
          <el-form-item label="上下比值：">
            <el-input v-model="form.upDownRatio" :disabled="disabled"></el-input>
          </el-form-item>
        </el-col>
        <el-col  :sm="24" :md="12">
          <el-form-item label="左右比值：">
            <el-input v-model="form.leftRightRatio" :disabled="disabled"></el-input>
          </el-form-item>
        </el-col>
        <el-col  :sm="24" :md="12">
          <el-form-item label="自律神经：">
            <el-input v-model="form.selfControlNerve" :disabled="disabled"></el-input>
          </el-form-item>
        </el-col>
        <el-col  :sm="24" :md="12">
          <el-form-item label="平均体能">
            <el-input v-model="form.averageStamina" :disabled="disabled"></el-input>
          </el-form-item>
        </el-col>
        <el-col  :sm="24" :md="12">
          <el-form-item label="心血管风险提示：" >
            <el-select v-model="form.chdRisk" placeholder="" style="width:100%" :disabled="disabled">
              <el-option label="低" value="低"></el-option>
              <el-option label="中" value="中"></el-option>
              <el-option label="高" value="高"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

      </el-row>
    </el-form>
    <el-form :disabled="disabled">
      <!-- HyperQ 自定义结构表格 -表头 -->
      <el-row class="alignCenter">
        <el-col :span="2">
          <el-row>
            <el-col :span="24">\&nbsp;</el-col>
          </el-row>
        </el-col>
        <el-col :span="22">
          <el-row>
            <el-col :span="2"> 大肠经 </el-col>
            <el-col :span="2"> 肺经 </el-col>
            <el-col :span="2"> 胃经 </el-col>
            <el-col :span="2"> 脾经 </el-col>
            <el-col :span="2"> 小肠 </el-col>
            <el-col :span="2"> 心经 </el-col>
            <el-col :span="2"> 膀胱经 </el-col>
            <el-col :span="2"> 肾经 </el-col>
            <el-col :span="2"> 三焦经 </el-col>
            <el-col :span="2"> 心包经 </el-col>
            <el-col :span="2"> 胆经 </el-col>
            <el-col :span="2"> 肝经 </el-col>
          </el-row>
        </el-col>
      </el-row>
      <!-- EMC/CCT 自定义结构表格 -第一行 左-->
      <el-row class="alignCenter">
        <el-col :span="2">
          <el-row>
            <el-col :span="24">左</el-col>
          </el-row>
        </el-col>
        <el-col :span="22">
          <el-row>
            <el-col :span="2">
              <!-- {{ form.dachangeLeft }} -->
              <el-select v-model="form.dachangeLeft" placeholder=".">
                <el-option
                  v-for="item in emcOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <!-- {{ form.feiLeft }} -->
              <el-select v-model="form.feiLeft" placeholder=".">
                <el-option
                  v-for="item in emcOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <!-- {{ form.weiLeft }} -->
              <el-select v-model="form.weiLeft" placeholder=".">
                <el-option
                  v-for="item in emcOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <!-- {{ form.piLeft }} -->
              <el-select v-model="form.piLeft" placeholder=".">
                <el-option
                  v-for="item in emcOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <!-- {{ form.xiaochangeLeft }} -->
              <el-select v-model="form.xiaochangeLeft" placeholder=".">
                <el-option
                  v-for="item in emcOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <!-- {{ form.xinLeft }} -->
              <el-select v-model="form.xinLeft" placeholder=".">
                <el-option
                  v-for="item in emcOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <!-- {{ form.pangguanLeft }} -->
              <el-select v-model="form.pangguanLeft" placeholder=".">
                <el-option
                  v-for="item in emcOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <!-- {{ form.shenLeft }} -->
              <el-select v-model="form.shenLeft" placeholder=".">
                <el-option
                  v-for="item in emcOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <!-- {{ form.sanjiaoLeft }} -->
              <el-select v-model="form.sanjiaoLeft" placeholder=".">
                <el-option
                  v-for="item in emcOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <!-- {{ form.xinbaoLeft }} -->
              <el-select v-model="form.xinbaoLeft" placeholder=".">
                <el-option
                  v-for="item in emcOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <!-- {{ form.danLeft }} -->
              <el-select v-model="form.danLeft" placeholder=".">
                <el-option
                  v-for="item in emcOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <!-- {{ form.ganLeft }} -->
              <el-select v-model="form.ganLeft" placeholder="." >
                <el-option
                  v-for="item in emcOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <!-- EMC/CCT 自定义结构表格 -第二行 右-->
      <el-row class="alignCenter">
        <el-col :span="2">
          <el-row>
            <el-col :span="24">右</el-col>
          </el-row>
        </el-col>
        <el-col :span="22">
          <el-row>
            <el-col :span="2">
              <!-- {{ form.dachangeRight }} -->
              <el-select v-model="form.dachangeRight" placeholder=".">
                <el-option
                  v-for="item in emcOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <!-- {{ form.feiRight }} -->
              <el-select v-model="form.feiRight" placeholder=".">
                <el-option
                  v-for="item in emcOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <!-- {{ form.weiRight }} -->
              <el-select v-model="form.weiRight" placeholder=".">
                <el-option
                  v-for="item in emcOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <!-- {{ form.piRight }} -->
              <el-select v-model="form.piRight" placeholder=".">
                <el-option
                  v-for="item in emcOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <!-- {{ form.xiaochangeRight }} -->
              <el-select v-model="form.xiaochangeRight" placeholder=".">
                <el-option
                  v-for="item in emcOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <!-- {{ form.xinRight }} -->
              <el-select v-model="form.xinRight" placeholder=".">
                <el-option
                  v-for="item in emcOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <!-- {{ form.pangguanRight }} -->
              <el-select v-model="form.pangguanRight" placeholder=".">
                <el-option
                  v-for="item in emcOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <!-- {{ form.shenRight }} -->
              <el-select v-model="form.shenRight" placeholder=".">
                <el-option
                  v-for="item in emcOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <!-- {{ form.sanjiaoRight }} -->
              <el-select v-model="form.sanjiaoRight" placeholder=".">
                <el-option
                  v-for="item in emcOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <!-- {{ form.xinbaoRight }} -->
              <el-select v-model="form.xinbaoRight" placeholder=".">
                <el-option
                  v-for="item in emcOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <!-- {{ form.danRight }} -->
              <el-select v-model="form.danRight" placeholder=".">
                <el-option
                  v-for="item in emcOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <!-- {{ form.ganRight }} -->
              <el-select v-model="form.ganRight" placeholder=".">
                <el-option
                  v-for="item in emcOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row> </el-col
      ></el-row>
    </el-form>
    <!-- <hr/> -->
    <el-row :gutter="30" style="margin-top:20px">
      <el-col :span="24" class="alignCenter" >
        <el-button
          :loading="submitting"
          type="primary"
          size="medium"
          :disabled="form.emcFile === ''"
          @click="_updateExamEmcNew"
          class="fullWidth"
          v-show="!disabled"
          >保存</el-button
        >
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { emcOptions, ExamStatesValue } from "../../utils/constants";
import { Util_updateExamState } from "../../utils/util";
import {
  getExamEmcNew,
  updateExamEmcNew,
  updateExamState,
  uploadFile,
  download,
} from "../../api/userExamService";

export default {
  name: "Emc",
  props: {
    examUuid: String,
    disabled: Boolean,
    emcDisabled:Boolean,
  },
  data() {
    return {
      submitting: false,
      upload_file: "",
      hyperQFileUrl: "",
      //基础检查
      form: {
        //examid
        examUuid: "",
        //比值：输入框
        leftRightRatio: "",
        yinYangRatio: "",
        upDownRatio: "",
        selfControlNerve: "",
        averageStamina: "",
        chdRisk: "",
        emcFile: "",
        // 自制表格内容
        //大肠经 //经
        dachangeLeft: "",
        dachangeRight: "",
        //肺经
        feiLeft: "",
        feiRight: "",
        //胃经
        weiLeft: "",
        weiRight: "",
        //脾经
        piLeft: "",
        piRight: "",
        //小肠
        xiaochangeLeft: "",
        xiaochangeRight: "",
        //心经
        xinLeft: "",
        xinRight: "",
        //膀胱经
        pangguanLeft: "",
        pangguanRight: "",
        //肾经
        shenLeft: "",
        shenRight: "",
        //三焦经
        sanjiaoLeft: "",
        sanjiaoRight: "",
        //心包经
        xinbaoLeft: "",
        xinbaoRight: "",
        //胆经
        danLeft: "",
        danRight: "",
        //肝经
        ganLeft: "",
        ganRight: "",
      },
      rules: {
        upload_file: [{required: true}]
      },
      emcOptions: emcOptions,
    
    };
  },
  methods: {
    tirggerFile(e) {
      console.log(e.target.files[0]);
    },
    //获取基础问询
    _getExamEmcNew() {
      getExamEmcNew(this.examUuid).then((res) => {
        if (res.success) {
          if (res.data[0]) {
            // this.model = res.data[0];
            //将数据转化为合适的格式后，赋值给examEmc (这是前端展示的格式)
            this.form = res.data[0];
          }
        } else {
          this.$message({ message: res.description, type: "error" });
        }
        // console.log("form", this.form);
      });
    },
    //更新基础问询
    _updateExamEmcNew() {
      //转换格式发送给后端;
      let postModel = this.form;
      this.submitting = true;
      updateExamEmcNew(postModel).then((res) => {
        this.submitting = false;
        if (res.success) {
          this.$message({ message: res.description, type: "success"});
          //更新检查状态后，重新获取检查信息
          this._updateExamState(ExamStatesValue.EMC_50, this._getExamEmcNew);
        } else {
          this.$message({
            message: res.description,
            type: "warning",
          });
        }
      })
      .catch(e=> {
        this.submitting = false;
        console.log(e)
      });
    },
    //更新检查状态、并重新获取更新的信息
    _updateExamState(state, reloadFunc) {
      //如果已到达，则将其状态改为30:基础问询中
      Util_updateExamState(
        this.examUuid,
        state,
        updateExamState,
        reloadFunc,
        this.$message
      );
    },
    _uploadFile() {
      let file = document.querySelector("#fileinput_emc").files[0];
      let isXLS = this.isXLS(file.name);
      //判断文件类是是否为pdf
      if (!isXLS) {
        this.$message({ message: "请上传xls格式的文件", type: "warning" });
        return;
      }
      // let file = document.querySelector("#fileinput").files[0];
      let formData = new FormData();
      formData.append("file", file);
      //路径参数 "examUuid/fileType"
      let params = this.examUuid + "/" + "xls" + "/" + false;
      uploadFile(params, formData)
        .then((res) => {
          if (res.success) {
            if (res.data[0]) {
              this.form.emcFile = res.data[0];
              this._updateExamEmcNew();
            }
            // this._getExamHyperq();
            this.$message({ message: res.description, type: "success" });
          } else {
            this.$message({ message: res.description, type: "warning" });
          }
        })
        .catch((e) => {
          this.$message({ message: e, type: "error" });
        });

    },
    isXLS(fileName) {
      let pattern = /.xls/g;
      return pattern.test(fileName);
    },
    
  },

  created() {
    this.form.examUuid = this.examUuid;
    this.emcFileUrl = download(this.examUuid + "/xls");
    this._getExamEmcNew();
  },
};
</script>

<style scoped>
.small-input {
  width: 150px;
  margin-right: 20px;
}
.fullWidth {
  width: 100%;
}

.fr {
  float: right;
}
.fl {
  float: left;
}
.radio-margin {
  margin-right: 10px;
}
.radio-margin-large {
  margin-right: 80px;
}

.alignCenter {
  text-align: center;
}
.alignRight {
  text-align: right;
}
</style>
